<template>
  <v-card>
    <v-toolbar flat>
      <v-card-title>
        {{ editedItem && editedItem.id ? `Editar Post #${editedItem.id}` : 'Nuevo Post' }}
      </v-card-title>
      <!--v-spacer/>
      <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn-->
    </v-toolbar>

    <v-divider/>

    <v-card-text>
      <v-form ref="formRef" v-model="valid">
        <v-row class="ma-0 pt-4">
          <!-- Influencer Autocomplete (guarda sólo ID) -->
          <v-col cols="12" sm="8">
            <v-autocomplete
              v-model="influencerModel"
              :items="entriesInfluencers"
              :loading="isLoadingInfluencers"
              :search-input.sync="influencerSearch"
              :filter="() => true"
              clearable
              return-object
              item-text="__label"
              item-value="id"
              label="Influencer"
              prepend-inner-icon="mdi-account-search"
              :rules="[req]"
              dense
            >
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-avatar v-if="item.avatar" size="28">
                    <img :src="item.avatar" alt="">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.__label }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.handle">{{ item.handle }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>

            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-select
              v-model="form.provider"
              :items="providers"
              label="Tipo"
              dense
              :rules="[req]"
              item-text="text"
              item-value="value"
            />
          </v-col>

          <!--v-col cols="12" sm="3">
            <v-select v-model="form.type" :items="types" label="Tipo Media" dense :rules="[req]" />
          </v-col-->

          <v-col cols="12" sm="8">
            <v-text-field
              v-model="form.url"
              label="URL"
              dense
            />
          </v-col>

          <v-col cols="12" sm="4">
            <v-menu
              v-model="menuDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  readonly
                  dense
                  label="Fecha de publicación"
                  :value="form.published_at"
                  :rules="[req]"
                />
              </template>
              <v-date-picker v-model="form.published_at" @input="menuDate=false"/>
            </v-menu>
          </v-col>

          <v-col cols="12">
            <v-textarea
              outlined
              v-model="form.caption"
              rows="3"
              auto-grow
              label="Caption"
              dense
              :rules="[req]"
            />
          </v-col>

          <!-- Categorías (sin crear con Enter) + botón para diálogo -->
          <v-col cols="12">
            <v-autocomplete
              v-model="categoryModel"
              :items="categories"
              item-text="name"
              item-value="id"
              label="Selecciona categorías"
              multiple
              chips
              small-chips
              clearable
              dense
              :loading="catLoading"
              :search-input.sync="categorySearch"
              :filter="() => true"
              @change="syncFormCategories"
              :rules="[arrReq]"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeCategoryChip(data.item)"
                  small
                >
                  {{ data.item.name }}
                </v-chip>
              </template>

              <template v-slot:no-data>
                <div class="px-4 py-3 grey--text text--darken-1">
                  No hay resultados. ¿Quieres
                  <a href="javascript:void(0)" @click="openCreateCategoryDialog">crear una nueva categoría</a>?
                </div>
              </template>
            </v-autocomplete>

            <div class="d-flex align-center">
              <v-spacer/>
              <v-btn x-small text color="primary" class="elevation-0" @click="openCreateCategoryDialog">
                <v-icon left small>mdi-plus</v-icon> Nueva categoría
              </v-btn>
            </div>
          </v-col>

          <!-- Media Dropzone -->
          <v-col cols="12">
            <div class="subtitle-2 mb-2">Media</div>
            <vue-dropzone
              ref="dz"
              id="roster-dropzone"
              :options="dropzoneOptions"
              @vdropzone-success="onUploadSuccess"
              @vdropzone-removed-file="onFileRemoved"
            >
              <div class="dz-message">Arrastra archivos o haz click para subir</div>
            </vue-dropzone>

            <!-- Previsualización simple -->
            <div class="d-flex flex-wrap mt-2">
              <div
                v-for="(src, i) in form.media"
                :key="`${src}-${i}`"
                class="media-thumb mr-2 mb-2"
              >
                <video
                  v-if="isVideo(src)"
                  :src="src.startsWith('http') ? src : (FILES_BASE_URL + src)"
                  muted
                />
                <v-img
                  v-else
                  :src="src.startsWith('http') ? src : (FILES_BASE_URL + src)"
                  contain
                  height="100"
                  width="100"
                />
                <v-btn x-small icon class="remove-btn" @click="removeMedia(i)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Error de media/URL cuando intentan guardar incompleto -->
            <div v-if="attemptedSubmit && !hasMediaOrUrl" class="error--text text-caption mt-2">
              Agrega al menos un archivo en Media o proporciona una URL.
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider/>

    <v-card-actions>
      <v-spacer/>
      <v-btn text @click="$emit('close')">Cancelar</v-btn>
      <v-btn
        color="primary"
        class="elevation-0"
        :loading="saving"
        :disabled="!isFormComplete || saving || !valid"
        @click="save"
      >
        Guardar
      </v-btn>
    </v-card-actions>

    <!-- ===== Diálogo Nueva Categoría ===== -->
    <v-dialog v-model="createCatDialog" max-width="520px" persistent>
      <v-card>
        <v-toolbar flat>
          <v-card-title>Crear categoría</v-card-title>
          <v-spacer/>
          <v-btn icon @click="closeCreateCategoryDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-divider/>
        <v-card-text class="pt-4">
          <v-form ref="catFormRef" v-model="catFormValid">
            <v-text-field
              v-model="newCat.name"
              label="Nombre"
              :rules="[req]"
              autofocus
              @keyup.enter.exact.prevent="createCategory"
            />
            <v-select
              v-model="newCat.type"
              :items="catTypes"
              label="Tipo"
              :rules="[req]"
              item-text="text"
              item-value="value"
            />
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="closeCreateCategoryDialog">Cancelar</v-btn>
          <v-btn color="primary" class="elevation-0" :loading="creatingCat" @click="createCategory">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ===== /Diálogo Nueva Categoría ===== -->
  </v-card>
</template>

<script>
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'RosterForm',
  components: { vueDropzone: vue2Dropzone },
  props: {
    editedItem: { type: Object, default: null },
    currentUser: { type: Object, required: true },
  },
  data: () => ({

    FILES_BASE_URL: 'https://peach.blitzhub.mx/files/',

    valid: true,
    saving: false,
    menuDate: false,

    providers: [
      {text:'TikTok', value:'TikTok Content'},
      {text:'Instagram Story', value:'Instagram Story'},
      {text:'Instagram Post', value:'Instagram Post'},
      {text:'Case Study', value:'Case Study'},
    ],
    types: ['video', 'image', 'carrousel'],

    form: {
      id: null,
      influencer_id: null,
      provider: null,
      url: '',
      type: null,
      caption: '',
      published_at: '',
      media: [],
      categories: [],  // <-- array de números (IDs)
      user_id: null,
    },

    // ===== Influencer autocomplete =====
    influencerModel: null,
    entriesInfluencers: [],
    influencerSearch: '',
    isLoadingInfluencers: false,
    _influencerDebounce: null,

    // ===== Categorías =====
    categories: [],        // [{ id, name, type }]
    catLoading: false,
    categoryModel: [],     // array de objetos seleccionados (de categories)
    categorySearch: '',
    _catDebounce: null,

    // Diálogo crear categoría
    createCatDialog: false,
    newCat: {
      name: '',
      type: null
    },
    catTypes: [
      { text: '🎤  Entretenimiento y Expresión', value: '🎤  Entretenimiento y Expresión' },
      { text: '🎨  Arte, Creatividad y Cultura', value: '🎨  Arte, Creatividad y Cultura' },
      { text: '💄 Belleza y Estilo de Vida', value: '💄 Belleza y Estilo de Vida' }
    ],
    creatingCat: false,
    catFormValid: true,

    dropzoneOptions: {
      url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sale/file",
      addRemoveLinks: true,
      dictDefaultMessage: 'Suelta archivos aquí para subir',
      acceptedFiles: 'image/*,video/*',
    },

    req: v => !!v || 'Requerido',
    arrReq: v => (Array.isArray(v) && v.length > 0) || 'Requerido',

    attemptedSubmit: false,
  }),
  watch: {
    // Sincroniza el id del influencer
    influencerModel (val) {
      this.form.influencer_id = val && val.id ? (Number(val.id) || val.id) : null
    },

    // Búsqueda remota de influencers (debounce)
    influencerSearch (val) {
      if (this._influencerDebounce) clearTimeout(this._influencerDebounce)
      this._influencerDebounce = setTimeout(() => {
        this.searchInfluencers(val)
      }, 300)
    },

    // Búsqueda/recarga de categorías (debounce, servidor)
    categorySearch (val) {
      if (this._catDebounce) clearTimeout(this._catDebounce)
      this._catDebounce = setTimeout(() => {
        this.fetchCategories(val)
      }, 300)
    },

    editedItem: {
      immediate: true,
      handler (val) {
        if (val && val.id) {
          // Normalizaciones robustas desde el objeto que trae la API
          const influencerObj = val.influencer || val.influencer_data || null
          const influencerId = val.influencer_id
            ?? (influencerObj && (Number(influencerObj.id) || influencerObj.id))
            ?? null

          const userId = (val.user_id && (val.user_id.id || Number(val.user_id)))
            || (this.currentUser && this.currentUser.id)
            || null

          const categoriesIds = (val.categories || []).map(c => +((c.id ?? c))).filter(n => Number.isFinite(n))

          this.form = {
            id: val.id,
            influencer_id: influencerId,
            provider: val.provider || null,
            url: val.url || '',
            type: val.type || null,
            caption: val.caption || '',
            published_at: (val.published_at || '').slice(0,10),
            media: Array.isArray(val.media) ? [...val.media] : [],
            categories: Array.from(new Set(categoriesIds)),
            user_id: userId,
          }

          // Preseleccionar influencer visual en el autocomplete
          const inf = influencerObj
          if (inf && (inf.id || this.form.influencer_id)) {
            const obj = this.normalizeInfluencer(inf)
            this.influencerModel = obj
            this.entriesInfluencers = [obj]
          } else {
            this.influencerModel = null
          }

          // Chips visuales de categorías
          this.categoryModel = (val.categories || []).map(c => ({
            id: +(c.id ?? c),
            name: c.name || `${c.id ?? c}`,
            type: c.type || null
          }))
        } else {
          this.resetForm()
        }

        // cargar categorías inicial
        this.fetchCategories()
      }
    }
  },
  computed: {
    hasMediaAndUrl () {
      const hasMedia = Array.isArray(this.form.media) && this.form.media.length > 0
      const hasUrl = !!(this.form.url && this.form.url.trim().length > 0)
      return hasMedia && hasUrl
    },
    isFormComplete () {
      const hasInfluencer = !!(this.influencerModel?.id || this.form.influencer_id)
      const hasProvider   = !!this.form.provider
      const hasDate       = !!this.form.published_at
      const hasCaption    = !!(this.form.caption && this.form.caption.trim().length > 0)
      const hasCategories = (Array.isArray(this.categoryModel) && this.categoryModel.length > 0)
                           || (Array.isArray(this.form.categories) && this.form.categories.length > 0)
      return hasInfluencer && hasProvider && hasDate && hasCaption && hasCategories && this.hasMediaAndUrl
    }
  },
  methods: {
    resetForm(){
      this.form = {
        id: null,
        influencer_id: null,
        provider: null,
        url: '',
        type: null,
        caption: '',
        published_at: '',
        media: [],
        categories: [],
        user_id: (this.currentUser && this.currentUser.id) || null,
      }
      this.influencerModel = null
      this.entriesInfluencers = []
      this.categoryModel = []
      this.categorySearch = ''
      this.attemptedSubmit = false
    },

    // ===== Media helpers =====
    isVideo(url){ return /\.mp4($|\?)/i.test(url || '') },
    onUploadSuccess(file, response){
      const url = response?.file || response?.url
      if (url) this.form.media.push(url)
    },
    onFileRemoved(file){ /* opcional: borrar en servidor */ },
    removeMedia(i){ this.form.media.splice(i,1) },

    // ===== Influencers (búsqueda remota) =====
    normalizeInfluencer(raw){
      const id = raw.id
      const name =
        raw.name ||
        raw.full_name ||
        `${raw.first_name || ''} ${raw.last_name || ''}`.trim() ||
        (raw.social_networks && raw.social_networks.instagram) ||
        `#${id}`
      const handle =
        (raw.social_networks && (raw.social_networks.instagram || raw.social_networks.tiktok)) ||
        raw.handle ||
        ''
      const avatar = raw.profile_photo_path
        ? (raw.profile_photo_path.startsWith('http')
            ? raw.profile_photo_path
            : null)
        : null
      return { id, __label: name, handle, avatar }
    },

    async searchInfluencers(val){
      const q = (val == null ? '' : String(val)).trim()
      if(this.form.influencer_id!=null){return}
      if (q === '' && this.form.influencer_id==null) {
        // limpiar items si no hay búsqueda
        this.entriesInfluencers = []
        return
      }
      if (this.isLoadingInfluencers) return
      this.isLoadingInfluencers = true

      try{
        // limpiar SIEMPRE antes de cargar nuevos resultados
        this.entriesInfluencers = []

        let extra = ''
        if (this.currentUser && (this.currentUser.role === 'Talent Agent' || this.currentUser.role === 'Booking') && this.currentUser.id!='579') {
          extra = `&filter[parent_id]=${this.currentUser.id}`
        }
        const url =
          `${process.env.VUE_APP_BACKEND_ROUTE}api/v1/influencer/search?filter[social_networks]=${encodeURIComponent(q)}${extra}`

        const res = await axios.get(url)
        const list = Array.isArray(res.data?.data) ? res.data.data : (res.data || [])
        // Rellenar SOLO con la respuesta del servidor
        this.entriesInfluencers = list.map(this.normalizeInfluencer)
      } finally {
        this.isLoadingInfluencers = false
      }
    },

    // ===== Categorías =====
    async fetchCategories (name = '') {
      try {
        this.catLoading = true
        const params = {}
        if (name && name.trim().length >= 2) {
          // si tu API soporta buscar por nombre, ajusta aquí (p.ej. filter[name])
          params['name'] = name.trim()
        }
        const { data } = await axios.get(`${process.env.VUE_APP_BACKEND_ROUTE}api/v1/categories`, { params })
        const list = Array.isArray(data?.data) ? data.data : data

        // normaliza y dedup por id
        const map = new Map()
        for (const c of list) {
          const item = { id: +c.id, name: c.name, type: c.type || null }
          map.set(item.id, item)
        }
        this.categories = Array.from(map.values())
      } finally {
        this.catLoading = false
      }
    },

    // mantener form.categories como array de números
    syncFormCategories () {
      const ids = (this.categoryModel || []).map(c => +c.id).filter(n => Number.isFinite(n))
      this.form.categories = Array.from(new Set(ids))
    },

    removeCategoryChip (item) {
      const id = +item.id
      this.categoryModel = this.categoryModel.filter(c => +c.id !== id)
      this.syncFormCategories()
    },

    openCreateCategoryDialog () {
      this.newCat = { name: (this.categorySearch || '').trim(), type: null }
      this.createCatDialog = true
    },
    closeCreateCategoryDialog () {
      this.createCatDialog = false
      this.newCat = { name: '', type: null }
    },

    async createCategory () {
      if (!this.$refs.catFormRef.validate()) return
      if (this.creatingCat) return
      this.creatingCat = true
      try {
        // Evita duplicados por nombre exacto (case-insensitive)
        const exists = this.categories.find(c => c.name.toLowerCase() === this.newCat.name.trim().toLowerCase())
        if (exists) {
          this.pushCategoryToModel(exists)
          this.closeCreateCategoryDialog()
          return
        }

        const { data } = await axios.post(
          `${process.env.VUE_APP_BACKEND_ROUTE}api/v1/categories`,
          { name: this.newCat.name.trim(), type: this.newCat.type }
        )

        const cat = Array.isArray(data?.data) ? data.data[0] : (data?.data || data)
        const created = { id: +cat.id, name: cat.name, type: cat.type || null }

        // agregar al catálogo sin duplicar
        if (!this.categories.find(c => +c.id === +created.id)) {
          this.categories = [created, ...this.categories]
        }

        // seleccionarlo y reflejar IDs en el form
        this.pushCategoryToModel(created)

        this.closeCreateCategoryDialog()
      } finally {
        this.creatingCat = false
      }
    },

    pushCategoryToModel (cat) {
      if (!this.categoryModel.find(c => +c.id === +cat.id)) {
        this.categoryModel = [...this.categoryModel, cat]
      }
      this.syncFormCategories()
    },

    // ===== Save =====
    async save(){
      this.attemptedSubmit = true
      this.syncFormCategories()

      // valida reglas de Vuetify + requisitos adicionales
      const baseValid = this.$refs.formRef.validate()
      if (!baseValid || !this.isFormComplete) return

      this.saving = true
      try{
        this.form.user_id = this.form.user_id || (this.currentUser && this.currentUser.id) || null

        const payload = {
          ...this.form,
          influencer_id: this.influencerModel && this.influencerModel.id
            ? this.influencerModel.id
            : this.form.influencer_id || null,
          categories: this.form.id ? this.categoryModel.map(c => c.id*1) : this.categoryModel.map(n => +n), // números
        }

        if (payload.id) {
          await axios.patch(`${process.env.VUE_APP_BACKEND_ROUTE}api/v1/roster/${payload.id}`, payload)
        } else {
          await axios.post(`${process.env.VUE_APP_BACKEND_ROUTE}api/v1/roster`, payload)
        }
        this.$emit('saved')
      }catch(e){
        this.$emit('close')
        this.$nextTick(()=> this.$root.$emit('snackbar', { color:'error', message:'No se pudo guardar' }))
      }finally{
        this.saving = false
      }
    },
  }
}
</script>

<style scoped>
.media-thumb{
  position: relative;
  width: 100px;
  height: 100%;
  min-height: 100px;
  background: #f2f2f2;
  display: grid;
  place-items: center;
  overflow: hidden;
  border-radius: 6px;
}
.media-thumb video{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.remove-btn{
  position: absolute;
  top: -8px;
  right: -8px;
  background: white;
  border: 1px solid #ddd;
}
</style>
